import React from 'react';
import { useNode, BuilderComponent, BuilderComponentProps, getFontStyle, DesignMode } from '@mnz/builder';
import Box from '@mui/material/Box';
import Link from '../../common/components/link/DesignLink';
import EmptyElement from '../../common/components/empty-element/EmptyElement';

import { getBorderCSS, hoverAnimationCss } from '../../common/style';
import EditCustomLink from './EditCustomLink';

export interface CustomLinkProps extends BuilderComponentProps {
    text?: string;
    link?: string;
}

export const CustomLink: BuilderComponent<CustomLinkProps> = ({ designSettings, text, link }) => {
    const {
        connectors: { connect, drag },
        query: { getOptions },
        hidden,
    } = useNode((node) => ({
        hidden: node.data.hidden,
    }));
    const canEdit = getOptions().enabled;

    if (hidden) return <></>;

    if (link === undefined && text === undefined) {
        if (!canEdit) return <></>;

        return (
            <Box
                ref={(ref: HTMLElement) => connect(drag(ref))}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '16px',
                    marginX: '35px',
                    cursor: 'pointer',
                }}
            >
                <EmptyElement
                    text={'Add Custom Link'}
                    xs={{ width: '100%', ...getFontStyle(designSettings, 'secondary', 'bold') }}
                />
            </Box>
        );
    }

    return (
        <Link url={link} isLiveMode={getOptions().mode === DesignMode.LIVE}>
            <Box
                sx={{
                    marginTop: '16px',
                    marginX: '35px',
                    ...hoverAnimationCss({ content: '"Custom Link"', active: canEdit }),
                }}
            >
                <Box
                    ref={(ref: HTMLElement) => connect(drag(ref))}
                    sx={{
                        ...getBorderCSS({
                            corner: designSettings.styles.corner,
                            color: designSettings.colors.button.color,
                            buttonStyle: designSettings.styles.button,
                        }),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        padding: '15px 43px',
                        cursor: 'pointer',
                    }}
                >
                    <Box
                        sx={{
                            color: designSettings.colors.buttonText.color,
                            ...getFontStyle(designSettings, 'secondary', 'bold'),
                            flexGrow: 1,
                            textAlign: 'center',
                        }}
                    >
                        {text ? text : link}
                    </Box>
                </Box>
            </Box>
        </Link>
    );
};

CustomLink.defaultProps = {};

CustomLink.settings = {
    displayName: 'Custom Link',
    related: {
        settings: EditCustomLink,
    },
    rules: {
        canDrag: () => false,
    },
    custom: {
        showBox: false,
    },
};
